<div class="schema-form-builder" [formGroup]="form">
  <ng-container [formGroupName]="formGroupName">
    @for (schema of schemas; track schema) {
      <div class="field">
        <label [for]="schema.name"></label>
        @if (schema.type === 'text') {
          <app-input-text
            [id]="schema.name"
            [name]="schema.name"
            [label]="schema.label"
            [required]="schema.required"
            fullWidth
            [maxlength]="schema.maxValue"
            [error]="hasErrors(schema.name)"
            [showMessages]="hasErrors(schema.name)"
            [formControlName]="schema.name">
          </app-input-text>
        }
        @if (schema.type === 'number') {
          <app-input-number
            [id]="schema.name"
            [name]="schema.name"
            [label]="schema.label"
            [required]="schema.required"
            fullWidth
            [max]="schema.maxValue"
            [error]="hasErrors(schema.name)"
            [showMessages]="hasErrors(schema.name)"
            [formControlName]="schema.name">
          </app-input-number>
        }
        @if (schema.type === 'select') {
          <app-input-select
            [id]="schema.name"
            [name]="schema.name"
            [label]="schema.label"
            [required]="schema.required"
            [options]="getOptions(schema)"
            valueProp="id"
            textProp="value"
            fullWidth
            [error]="hasErrors(schema.name)"
            [showMessages]="hasErrors(schema.name)"
            [formControlName]="schema.name">
          </app-input-select>
        }
        @if (schema.type === 'textarea') {
          <app-input-textarea
            [id]="schema.name"
            [name]="schema.name"
            [label]="schema.label"
            [required]="schema.required"
            [attr.maxlength]="schema.maxValue"
            [rows]="5"
            resize="vertical"
            fullWidth
            [error]="hasErrors(schema.name)"
            [showMessages]="hasErrors(schema.name)"
          [formControlName]="schema.name"></app-input-textarea>
        }
      </div>
    }
  </ng-container>
</div>
